export enum Current {
  UNSPECIFIED = 'UNSPECIFIED',
  AC = 'AC',
  DC = 'DC'
}

export enum Phase {
  UNKNOWN_NA,
  ONE,
  TWO,
  THREE
}

export enum Capability {
  CHARGING_PROFILE_CAPABLE = 'CHARGING_PROFILE_CAPABLE',
  CHARGING_PREFERENCES_CAPABLE = 'CHARGING_PREFERENCES_CAPABLE',
  CHIP_CARD_SUPPORT = 'CHIP_CARD_SUPPORT',
  CONTACTLESS_CARD_SUPPORT = 'CONTACTLESS_CARD_SUPPORT',
  CREDIT_CARD_PAYABLE = 'CREDIT_CARD_PAYABLE',
  DEBIT_CARD_PAYABLE = 'DEBIT_CARD_PAYABLE',
  PED_TERMINAL = 'PED_TERMINAL',
  REMOTE_START_STOP_CAPABLE = 'REMOTE_START_STOP_CAPABLE',
  RESERVABLE = 'RESERVABLE',
  RFID_READER = 'RFID_READER',
  START_SESSION_CONNECTOR_REQUIRED = 'START_SESSION_CONNECTOR_REQUIRED',
  TOKEN_GROUP_CAPABLE = 'TOKEN_GROUP_CAPABLE',
  UNLOCK_CAPABLE = 'UNLOCK_CAPABLE'
}

export enum ConnectorType {
  UNSPECIFIED = 'UNSPECIFIED',
  C_TYPE_1 = 'C_TYPE_1',
  C_TYPE_2 = 'C_TYPE_2',
  C_G105 = 'C_G105',
  C_CCS_1 = 'C_CCS_1',
  C_CCS_2 = 'C_CCS_2',
  CEE_7_7 = 'CEE_7_7',
  S_309_1P_16A = 'S_309_1P_16A',
  S_309_3P_16A = 'S_309_3P_16A',
  S_309_3P_32A = 'S_309_3P_32A',
  S_TYPE_2 = 'S_TYPE_2',
  S_TYPE_3 = 'S_TYPE_3',
  S_BS1361 = 'S_BS1361'
}

export interface Manufacturer {
  id?: number;
  code: string;
}

export interface Evse {
  id?: number;
  identifier: number;
  capabilities?: Capability[];
  connectors: Connector[];
}

export interface Connector {
  id?: number;
  maxAmp: number;
  phase: Phase;
  voltage: number;
  maxElectricPower: number | null;
  physicalReference: string | null;
  current: Current;
  connectorType: ConnectorType;
}

export interface ChargingStationType {
  id?: number;
  code: string;
  commercialCode: string | null;
  manufacturer: Manufacturer;
  evses: Evse[];
}
